// Widest breakpoint's column count — kept alongside the grid definition so a
// future column-count change here can't silently drift out of sync with the
// skeleton count in index.jsx.
export const MAX_GRID_COLUMNS = 4;

export const grid = {
    mt: 3,
    display: 'grid',
    gridTemplateColumns: {
        xs: '1fr',
        sm: 'repeat(2, minmax(0, 1fr))',
        lg: 'repeat(3, minmax(0, 1fr))',
        xl: `repeat(${MAX_GRID_COLUMNS}, minmax(0, 1fr))`,
    },
    gap: { xs: 2.5, md: 3 },
};

// VirtuosoGrid's List/Item — flex-wrap, not CSS grid. CSS grid's row-sizing
// algorithm lets a later item retroactively change an earlier row's height,
// which fights Virtuoso's own per-item height measurement and made its
// measured container height oscillate while scrolling (visible as the whole
// page growing/shrinking rapidly). Matches the layout react-virtuoso's own
// docs use for grid mode.
export const virtualizedList = {
    mt: 3,
    display: 'flex',
    flexWrap: 'wrap',
    gap: { xs: 2.5, md: 3 },
};

export const virtualizedItem = {
    boxSizing: 'border-box',
    flex: 'none',
    width: {
        xs: '100%',
        sm: 'calc(50% - 10px)',
        lg: 'calc(33.3333% - 16px)',
        xl: `calc(${100 / MAX_GRID_COLUMNS}% - 18px)`,
    },
};

export const footer = {
    display: 'flex',
    justifyContent: 'center',
    py: 4,
};

// End-of-list divider (EBL-13079) — copy is a placeholder pending final
// wording from Pat.
export const endOfList = {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    py: 4,
    color: 'var(--ecal-lightgrey)',
    fontSize: '0.875rem',
};

export const endOfListLine = {
    flex: 1,
    height: '1px',
    background: 'rgba(187,188,188,0.18)',
};

export const empty = {
    gridColumn: '1 / -1',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.015) 100%)',
    border: '1px solid rgba(187,188,188,0.12)',
    borderRadius: '22px',
    py: 8,
    textAlign: 'center',
    color: 'var(--ecal-lightgrey)',
    fontSize: '0.9375rem',
};
